import type { CadCategory } from '@shared/types';
import { Armchair, Cog, Building2, Printer } from 'lucide-react';
import { cn } from '@/lib/utils';
import { useTranslation } from 'react-i18next';

const CATEGORIES: Array<{ value: CadCategory; icon: typeof Armchair }> = [
  { value: 'furniture', icon: Armchair },
  { value: 'mechanical', icon: Cog },
  { value: 'architecture', icon: Building2 },
  { value: 'printing', icon: Printer },
];

export function CategorySection({
  value,
  onChange,
}: {
  value: CadCategory | undefined;
  onChange: (next: CadCategory) => void;
}) {
  const { t } = useTranslation('intake');
  return (
    <div className="grid grid-cols-2 gap-2 sm:grid-cols-4">
      {CATEGORIES.map((c) => {
        const Icon = c.icon;
        const active = c.value === value;
        return (
          <button
            key={c.value}
            type="button"
            onClick={() => onChange(c.value)}
            className={cn(
              'flex flex-col items-center gap-1 rounded-xl border px-3 py-2.5 text-xs transition',
              active
                ? 'border-synergy-blue bg-synergy-blue/10 text-synergy-blue'
                : 'border-synergy-neutral-700/40 bg-white/40 text-synergy-text-tertiary hover:border-synergy-blue/25',
            )}
          >
            <Icon className="h-4 w-4" />
            <span className="font-medium">{t(`categories.${c.value}.label`)}</span>
            <span className="text-[10px] text-synergy-text-tertiary/70">{t(`categories.${c.value}.hint`)}</span>
          </button>
        );
      })}
    </div>
  );
}
